import React, { createContext, useState } from "react";

const ParametrosProdutoContext = createContext();

const ParametrosProdutoContextProvider = ({ children }) => {
  /* AUXILIAR  */
  const [productLoading, setProductLoading] = useState(false);
  const [timerProductCode, setTimerProductCode] = useState(null);
  const [productTaxation, setProductTaxation] = useState(null);
  const [taxations, setTaxations] = useState([]);

  /* DADOS DO PRODUTO */
  const [itemId, setItemId] = useState(null);
  const [productData, setProductData] = useState(null);
  const [productError, setProductError] = useState({});
  const [productDataId, setProductDataId] = useState("");
  const [productDataIdStock, setProductDataIdStock] = useState("");
  const [productDataStock, setProductDataStock] = useState(null);
  const [productDataStockCode, setProductDataStockCode] = useState(null);
  const [productDataCode, setProductDataCode] = useState("");
  const [productDataDescription, setProductDataDescription] = useState("");
  const [productDataNcm, setProductDataNcm] = useState("");
  const [productDataCfop, setProductDataCfop] = useState(null);
  const [productDataUn, setProductDataUn] = useState("");
  const [productDataQuantity, setProductDataQuantity] = useState("1,0000");
  const [productDataUnityValue, setProductDataUnityValue] = useState("0,00000");
  const [productDataTotalValue, setProductDataTotalValue] = useState("0,00");
  const [productDataCest, setProductDataCest] = useState("");

  const [productOthersGtin, setProductOthersGtin] = useState("");
  const [productOthersTaxGtin, setProductOthersTaxGtin] = useState("");
  const [productOthersTipi, setProductOthersTipi] = useState("");
  const [productOthersDeliveryUn, setProductOthersDeliveryUn] = useState("");
  const [productOthersTaxUn, setProductOthersTaxUn] = useState("");
  const [productOthersTaxQuantity, setProductOthersTaxQuantity] =
    useState("1,0000");
  const [productOthersTaxValue, setProductOthersTaxValue] = useState("0,00");
  const [productOthersFreight, setProductOthersFreight] = useState("0,00");
  const [productOthersSafe, setProductOthersSafe] = useState("0,00");
  const [productOthersDiscount, setProductOthersDiscount] = useState("0,00000");
  const [productOthersExpense, setProductOthersExpense] = useState("0,00");
  const [productOthersWeightUn, setProductOthersWeightUn] = useState("0,000");
  const [productOthersWeightIm, setProductOthersWeightIm] = useState("0,00");
  const [productOthersSiscomex, setProductOthersSiscomex] = useState("0,00");
  const [productOthersAdditional, setProductOthersAdditional] = useState("");
  const [
    productOthersConversionFactorTax,
    setProductOthersConversionFactorTax,
  ] = useState(1.0);

  const [loading, setLoading] = useState(null);

  /* ICMS */

  const [productIcmsListSource] = useState([
    {
      label: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
      value: "0",
    },
    {
      label:
        "1 - Estrangeira - Importação Direta, exceto a indicada no código 6",
      value: "1",
    },
    {
      label:
        "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
      value: "2",
    },
    {
      label:
        "3 - Nacional - Mercadoria ou bem com conteúdo de importação inferior ou igual a 40%",
      value: "3",
    },
    {
      label:
        "4 - Nacional - Cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam as legislações citadas nos ajustes",
      value: "4",
    },
    {
      label:
        "5 - Nacional - Mercadoria ou bem com conteúdo de importação inferior ou igual a 40%",
      value: "5",
    },
    {
      label:
        "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista da CAMEX",
      value: "6",
    },
    {
      label:
        "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista da CAMEX",
      value: "7",
    },
    {
      label:
        "8 - Nacional - Mercadoria ou bem com Conteúdo de Importação superior a 70%",
      value: "8",
    },
  ]);

  const [productIcmsSource, setProductIcmsSource] = useState({
    label: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
    value: "0",
  });

  const [productIcmsListNormalTaxationSituation] = useState([
    {
      label: "00 - Tributada integralmente",
      value: "00",
    },
    {
      label: "10 - Tributada com cobrança do ICMS por ST",
      value: "10",
    },
    {
      label: "20 - Com redução da base de cálculo",
      value: "20",
    },
    {
      label: "30 - Isenta ou não tributada e com cobrança de ICMS por ST",
      value: "30",
    },
    {
      label: "40 - Isenta",
      value: "40",
    },
    {
      label: "41 - Não tributada",
      value: "41",
    },
    {
      label: "50 - Suspensão",
      value: "50",
    },
    {
      label: "51 - Diferimento",
      value: "51",
    },
    {
      label: "60 - Cobrado anteriormente por ST",
      value: "60",
    },
    {
      label: "70 - Com redução da base de cálculo e cobrança do ICMS por ST",
      value: "70",
    },
    {
      label: "90 - Outras",
      value: "90",
    },
  ]);

  const [productIcmsListSimpleTaxationSituation] = useState([
    { value: "101", label: "101 - Tributada com permissão de crédito" },
    { value: "102", label: "102 - Tributada sem permissão de crédito" },
    {
      value: "103",
      label: "103 - Isenção do ICMS para faixa de receita bruta",
    },
    {
      value: "201",
      label:
        "201 - Tributada com permissão de crédito e com cobrança do ICMS por ST",
    },
    {
      value: "202",
      label:
        "202 - Tributada sem permissão de crédito e com cobrança do ICMS por ST",
    },
    {
      value: "203",
      label:
        "203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por ST",
    },
    { value: "300", label: "300 - Imune" },
    { value: "400", label: "400 - Não tributada" },
    {
      value: "500",
      label:
        "500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação",
    },
    { value: "900", label: "900 - Outros" },
  ]);

  const [productIcmsListModality] = useState([
    { label: "Margem Valor agregado %", value: "0" },
    { label: "Pauta (Valor)", value: "1" },
    { label: "Preço tabelado Máx. (Valor)", value: "2" },
    { label: "Valor da Operação", value: "3" },
  ]);

  const [productImcsListReasonExemption] = useState([
    { label: "1 - Táxi", value: "1" },
    { label: "3 - Produto agropecuário/Uso na agropecuária", value: "3" },
    { label: "4 - Frotista/Locadora", value: "4" },
    { label: "5 - Diplomático/Consular", value: "5" },
    {
      label:
        "6 - Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio",
      value: "6",
    },
    { label: "7 - SUFRAMA", value: "7" },
    { label: "8 - Venda a Órgão Público", value: "8" },
    { label: "9 - Outros", value: "9" },
    { label: "10 - Deficiente Condutor", value: "10" },
    { label: "11 - Deficiente Não Condutor", value: "11" },
    {
      label: "12 - Órgão de fomento e desenvolvimento agropecuário",
      value: "12",
    },
    { label: "90 - Solicitado pelo Fisco", value: "90" },
  ]);

  const [productIcmsSituation, setProductIcmsSituation] = useState(null);
  const [productIcmsModality, setProductIcmsModality] = useState(null);
  const [productIcmsAfrmm, setProductIcmsAfrmm] = useState("0,00");
  const [productIcmsValueBc, setProductIcmsValueBc] = useState("0,00");
  const [productIcmsAliquot, setProductIcmsAliquot] = useState("0,00");
  const [productIcmsValue, setProductIcmsValue] = useState("0,00");
  const [productIcmsValueDes, setProductIcmsValueDes] = useState("0,00");
  const [productImcsMotivoDes, setProductImcsMotivoDes] = useState("");
  const [productIcmsPercentReduct, setProductIcmsPercentReduct] =
    useState("0,0000");
  const [productIcmsAliquotPoverty, setProductIcmsAliquotPoverty] =
    useState("0,00");
  const [productIcmsBcPoverty, setProductIcmsBcPoverty] = useState("0,00");
  const [productIcmsValuePoverty, setProductIcmsValuePoverty] =
    useState("0,00");

  // TAG ICMSUFDest
  const [productIcmsAliquotInterstate, setProductIcmsAliquotInterstate] =
    useState("0,00");
  const [productIcmsAliquotInternal, setProductIcmsAliquotInternal] =
    useState("0,00");
  const [productCheckIcmsDifal, setProductCheckIcmsDifal] = useState(false);

  /*Tag cBenef*/
  const [productIcmsCbenef, setProductIcmsCbenef] = useState("");

  /*Copia da Aliquota ICMS Interestadual para Aliquota ICMS*/
  const [
    productCopyIcmsAliquotInterstate,
    setProductCopyIcmsAliquotInterstate,
  ] = useState("");

  //ICMS ST
  const [productIcmsStListModality] = useState([
    { label: "Preço tabelado ou máximo sugerido", value: "0" },
    { label: "Lista Negativa (Valor)", value: "1" },
    { label: "Lista Positiva (Valor)", value: "2" },
    { label: "Lista Neutra (Valor)", value: "3" },
    { label: "Margem Valor agregado", value: "4" },
    { value: "5", label: "pauta (valor)" },
    { value: "6", label: "Valor da Operação" },
  ]);
  const [productIcmsStModality, setProductIcmsStModality] = useState(null);
  const [productIcmsStPercentAdd, setProductIcmsStPercentAdd] =
    useState("0,00");
  const [productIcmsAliquotCredit, setProductIcmsAliquotCredit] =
    useState("0,00");
  const [productIcmsCreditAprove, setProductIcmsCreditAprove] =
    useState("0,00");
  const [productIcmsStPercentReductBc, setProductIcmsStPercentReductBc] =
    useState("0,00");
  const [productIcmsStValueBc, setProductIcmsStValueBc] = useState("0,00");
  const [productIcmsStAliquot, setProductIcmsStAliquot] = useState("0,00");
  const [productIcmsStValue, setProductIcmsStValue] = useState("0,00");
  const [productIcmsStAliquotPoverty, setProductIcmsStAliquotPoverty] =
    useState("0,00");
  const [productIcmsStBcPoverty, setProductIcmsStBcPoverty] = useState("0,00");
  const [productIcmsStValuePoverty, setProductIcmsStValuePoverty] =
    useState("0,00");

  //SITUACAO 500 ICMS ST
  const [productIcmsStValueBcRet, setProductIcmsStValueBcRet] =
    useState("0,00");
  const [productIcmsAliquotSupCons, setProductIcmsAliquotSupCons] =
    useState("0,00");
  const [productIcmsOwnSubValue, setProductIcmsOwnSubValue] = useState("0,00");
  const [productIcmsStValueRet, setProductIcmsStValueRet] = useState("0,00");
  const [productIcmsStBcPovertyRet, setProductIcmsStBcPovertyRet] =
    useState("0,00");
  const [productIcmsStAliqPovertyRet, setProductIcmsStAliqPovertyRet] =
    useState("0,00");
  const [productIcmsStValuePovertyRet, setProductIcmsStValuePovertyRet] =
    useState("0,00");

  /* IPI */

  const [prodcuctIpiListSituation] = useState([
    { value: "00", label: " 00 - Entrada com recuperação de crédito" },
    { value: "01", label: " 01 - Entrada tributada com alíquota zero" },
    { value: "02", label: " 02 - Entrada isenta" },
    { value: "03", label: " 03 - Entrada não-tributada" },
    { value: "04", label: " 04 - Entrada imune" },
    { value: "05", label: " 05 - Entrada com suspensão" },
    { value: "49", label: " 49 - Outras entradas" },
    { value: "50", label: " 50 - Saída tributada" },
    { value: "51", label: " 51 - Saída tributada com alíquota zero" },
    { value: "52", label: " 52 - Saída isenta" },
    { value: "53", label: " 53 - Saída não-tributada" },
    { value: "54", label: " 54 - Saída imune" },
    { value: "55", label: " 55 - Saída com suspensão" },
    { value: "99", label: " 99 - Outras saídas" },
  ]);
  const [productIpiCenq, setProductIpiCenq] = useState("");
  const [productIpiSituation, setProductIpiSituation] = useState(null);
  const [productIpiBcValue, setProductIpiBcValue] = useState("0,00");
  const [productIpiAliquot, setProductIpiAliquot] = useState("0,00");
  const [productIpiValue, setProductIpiValue] = useState("0,00");

  /* IPI Devolvido */
  const [productIpiReturnedAliquot, setProductIpiReturnedAliquot] =
    useState("0,00");
  const [productIpiReturnedValue, setProductIpiReturnedValue] =
    useState("0,00");

  /* PIS */
  const [prodcuctPisListSituation] = useState([
    {
      label:
        "01 - Operação Tributável (base de cálculo = valor da operação alíquota normal (cumulativo/não cumulativo))",
      value: "01",
    },
    {
      label:
        "02 - Operação Tributável (base de cálculo = valor da operação (alíquota diferenciada))",
      value: "02",
    },
    {
      label:
        "03 - Operação Tributável (base de cálculo = quantidade vendida x alíquota por unidade de produto)",
      value: "03",
    },
    {
      label: "04 - Operação Tributável (tributação monofásica (alíquota zero))",
      value: "04",
    },
    {
      label: "05 - Operação Tributável (Substituição Tributária)",
      value: "05",
    },
    { label: "06 - Operação Tributável (alíquota zero)", value: "06" },
    { label: "07 - Operação Isenta da Contribuição", value: "07" },
    { label: "08 - Operação Sem Incidência da Contribuição", value: "08" },
    { label: "09 - Operação com Suspensão da Contribuição", value: "09" },
    { label: "49 - Outras Operações de Saída", value: "49" },
    {
      label:
        "50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      value: "50",
    },
    {
      label:
        "51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno",
      value: "51",
    },
    {
      label:
        "52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação",
      value: "52",
    },
    {
      label:
        "53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      value: "53",
    },
    {
      label:
        "54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      value: "54",
    },
    {
      label:
        "55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      value: "55",
    },
    {
      label:
        "56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      value: "56",
    },
    {
      label:
        "60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      value: "60",
    },
    {
      label:
        "61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno",
      value: "61",
    },
    {
      label:
        "62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação",
      value: "62",
    },
    {
      label:
        "63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      value: "63",
    },
    {
      label:
        "64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      value: "64",
    },
    {
      label:
        "65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      value: "65",
    },
    {
      label:
        "66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      value: "66",
    },
    { label: "67 - Crédito Presumido - Outras Operações", value: "67" },
    { label: "70 - Operação de Aquisição sem Direito a Crédito", value: "70" },
    { label: "71 - Operação de Aquisição com Isenção", value: "71" },
    { label: "72 - Operação de Aquisição com Suspensão", value: "72" },
    { label: "73 - Operação de Aquisição a Alíquota Zero", value: "73" },
    {
      label: "74 - Operação de Aquisição; sem Incidência da Contribuição",
      value: "74",
    },
    {
      label: "75 - Operação de Aquisição por Substituição Tributária",
      value: "75",
    },
    { label: "98 - Outras Operações de Entrada", value: "98" },
    { label: "99 - Outras Operações", value: "99" },
  ]);
  const [productPisSituation, setProductPisSituation] = useState(null);
  const [productPisPercentAliquot, setProductPisPercentAliquot] =
    useState("0,00");
  const [productPisAliquot, setProductPisAliquot] = useState("0,00");
  const [productPisBcValue, setProductPisBcValue] = useState("0,00");
  const [productPisValue, setProductPisValue] = useState("0,00");

  /* COFINS */
  const [productCofinsListSituation] = useState([
    {
      label:
        "01 - Operação Tributável (base de cálculo = valor da operação alíquota normal (cumulativo/não cumulativo))",
      value: "01",
    },
    {
      label:
        "02 - Operação Tributável (base de cálculo = valor da operação (alíquota diferenciada))",
      value: "02",
    },
    {
      label:
        "03 - Operação Tributável (base de cálculo = quantidade vendida x alíquota por unidade de produto)",
      value: "03",
    },
    {
      label: "04 - Operação Tributável (tributação monofásica (alíquota zero))",
      value: "04",
    },
    {
      label: "05 - Operação Tributável (Substituição Tributária)",
      value: "05",
    },
    { label: "06 - Operação Tributável (alíquota zero)", value: "06" },
    { label: "07 - Operação Isenta da Contribuição", value: "07" },
    { label: "08 - Operação Sem Incidência da Contribuição", value: "08" },
    { label: "09 - Operação com Suspensão da Contribuição", value: "09" },
    { label: "49 - Outras Operações de Saída", value: "49" },
    {
      label:
        "50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      value: "50",
    },
    {
      label:
        "51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno",
      value: "51",
    },
    {
      label:
        "52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação",
      value: "52",
    },
    {
      label:
        "53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      value: "53",
    },
    {
      label:
        "54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      value: "54",
    },
    {
      label:
        "55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      value: "55",
    },
    {
      label:
        "56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      value: "56",
    },
    {
      label:
        "60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      value: "60",
    },
    {
      label:
        "61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno",
      value: "61",
    },
    {
      label:
        "62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação",
      value: "62",
    },
    {
      label:
        "63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      value: "63",
    },
    {
      label:
        "64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      value: "64",
    },
    {
      label:
        "65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      value: "65",
    },
    {
      label:
        "66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      value: "66",
    },
    { label: "67 - Crédito Presumido - Outras Operações", value: "67" },
    { label: "70 - Operação de Aquisição sem Direito a Crédito", value: "70" },
    { label: "71 - Operação de Aquisição com Isenção", value: "71" },
    { label: "72 - Operação de Aquisição com Suspensão", value: "72" },
    { label: "73 - Operação de Aquisição a Alíquota Zero", value: "73" },
    {
      label: "74 - Operação de Aquisição; sem Incidência da Contribuição",
      value: "74",
    },
    {
      label: "75 - Operação de Aquisição por Substituição Tributária",
      value: "75",
    },
    { label: "98 - Outras Operações de Entrada", value: "98" },
    { label: "99 - Outras Operações", value: "99" },
  ]);
  const [productCofinsSituation, setProductCofinsSituation] = useState(null);
  const [productCofinsPercentAliquot, setProductCofinsPercentAliquot] =
    useState("0,00");
  const [productCofinsAliquot, setProductCofinsAliquot] = useState("0,00");
  const [productCofinsBcValue, setProductCofinsBcValue] = useState("0,00");
  const [productCofinsValue, setProductCofinsValue] = useState("0,00");

  /* II */
  const [productDiTable, setProductDiTable] = useState([]);
  // Valores
  const [productIIFob, setProductIIFob] = useState("0,00");
  const [productIIFreightIm, setProductIIFreightIm] = useState("0,00");
  const [productIISafeIm, setProductIISafeIm] = useState("0,00");
  const [productIICustomsValue, setProductIICustomsValue] = useState("0,00");
  // Tributos
  const [productIITaxIm, setProductIITaxIm] = useState("0,00");
  // Outras taxas
  const [productIITaxCustoms, setProductIITaxCustoms] = useState("0,00");
  const [productIIThc, setProductIIThc] = useState("0,00");
  const [productIIAntidumping, setProductIIAntidumping] = useState("0,00");
  const [productIIAFRMM, setProductIIAFRMM] = useState("0,00");
  const [productIIOthers, setProductIIOthers] = useState("0,00");
  // Inputs comentados
  const [productIIUnityValue, setProductIIUnityValue] = useState("0,00");
  const [productIIBcTax, setProductIIBcTax] = useState("0,00");
  const [productIIAliquot, setProductIIAliquot] = useState("0,00");
  const [productIIAliquotRed, setProductIIAliquotRed] = useState("0,00");
  const [productIIIof, setProductIIIof] = useState("0,00");

  /* B2B */
  const [productB2BNumber, setProductB2BNumber] = useState("");
  const [productB2BItem, setProductB2BItem] = useState("");

  /* Combustível */
  const [productFuelCodeAnp, setProductFuelCodeAnp] = useState("");
  const [productFuelUf, setProductFuelUf] = useState(null);
  const [productFuelDescAnp, setProductFuelDescAnp] = useState("");
  const [productFuelGlpPetroleum, setProductFuelGlpPetroleum] =
    useState("0,0000");
  const [productFuelNationalGas, setProductFuelNationalGas] =
    useState("0,0000");
  const [productFuelImportedGas, setProductFuelImportedGas] =
    useState("0,0000");
  const [productFuelValueWithoutICMS, setProductFuelValueWithoutICMS] =
    useState("0,0000");

  /**
   * Base de Calculo
   * */

  /**ICMS */
  const [productCheckIcmsFreight, setProductCheckIcmsFreight] = useState(true);
  const [productCheckIcmsSafe, setProductCheckIcmsSafe] = useState(true);
  const [productCheckIcmsOthers, setProductCheckIcmsOthers] = useState(true);
  const [productCheckIcmsDiscount, setProductCheckIcmsDiscount] =
    useState(true);

  /** IPI */
  const [productCheckIpiFreight, setProductCheckIpiFreight] = useState(true);
  const [productCheckIpiSafe, setProductCheckIpiSafe] = useState(true);
  const [productCheckIpiOthers, setProductCheckIpiOthers] = useState(true);
  const [productCheckIpiDiscount, setProductCheckIpiDiscount] = useState(true);

  /** PIS */
  const [productCheckPisFreight, setProductCheckPisFreight] = useState(true);
  const [productCheckPisSafe, setProductCheckPisSafe] = useState(true);
  const [productCheckPisOthers, setProductCheckPisOthers] = useState(true);
  const [productCheckPisDiscount, setProductCheckPisDiscount] = useState(true);
  const [productCheckPisDescIcms, setProductCheckPisDescIcms] = useState(true);

  /** COFINS */
  const [productCheckCofinsFreight, setProductCheckCofinsFreight] =
    useState(true);
  const [productCheckCofinsSafe, setProductCheckCofinsSafe] = useState(true);
  const [productCheckCofinsOthers, setProductCheckCofinsOthers] =
    useState(true);
  const [productCheckCofinsDiscount, setProductCheckCofinsDiscount] =
    useState(true);
  const [productCheckCofinsDescIcms, setProductCheckCofinsDescIcms] =
    useState(true);

  const [productExportDrawbackNumber, setProductExportDrawbackNumber] =
    useState(null);
  const [productIsIndirectExportation, setProductIsIndirectExportation] =
    useState(false);
  const [productExportRegisterNumber, setProductExportRegisterNumber] =
    useState(null);
  const [productExportAccessKey, setProductExportAccessKey] = useState(null);
  const [productExportQuantity, setProductExportQuantity] = useState("0,0000");

  return (
    <ParametrosProdutoContext.Provider
      value={{
        timerProductCode,
        setTimerProductCode,
        productData,
        setProductData,
        productDataId,
        setProductDataId,
        productLoading,
        setProductLoading,
        productDataIdStock,
        setProductDataIdStock,
        productDataStockCode,
        setProductDataStockCode,
        productError,
        setProductError,
        productDataStock,
        setProductDataStock,
        productDataCode,
        setProductDataCode,
        productDataDescription,
        setProductDataDescription,
        productDataNcm,
        setProductDataNcm,
        productDataCest,
        setProductDataCest,
        productDataCfop,
        setProductDataCfop,
        productDataUn,
        setProductDataUn,
        productDataQuantity,
        setProductDataQuantity,
        productDataUnityValue,
        setProductDataUnityValue,
        productDataTotalValue,
        setProductDataTotalValue,
        productOthersGtin,
        setProductOthersGtin,
        productOthersTaxGtin,
        setProductOthersTaxGtin,
        productOthersTipi,
        setProductOthersTipi,
        productOthersDeliveryUn,
        setProductOthersDeliveryUn,
        productOthersTaxUn,
        setProductOthersTaxUn,
        productOthersTaxQuantity,
        setProductOthersTaxQuantity,
        productOthersTaxValue,
        setProductOthersTaxValue,
        productOthersFreight,
        setProductOthersFreight,
        productOthersSafe,
        setProductOthersSafe,
        productOthersDiscount,
        setProductOthersDiscount,
        productOthersExpense,
        setProductOthersExpense,
        productOthersWeightUn,
        setProductOthersWeightUn,
        productOthersWeightIm,
        setProductOthersWeightIm,
        productOthersSiscomex,
        setProductOthersSiscomex,
        productOthersAdditional,
        setProductOthersAdditional,
        productOthersConversionFactorTax,
        setProductOthersConversionFactorTax,
        productIcmsSource,
        setProductIcmsSource,
        productIcmsListNormalTaxationSituation,
        productIcmsListSimpleTaxationSituation,
        productIcmsListModality,
        productImcsListReasonExemption,
        productIcmsStListModality,
        prodcuctIpiListSituation,
        prodcuctPisListSituation,
        productCofinsListSituation,
        productIcmsListSource,
        productIcmsSituation,
        setProductIcmsSituation,
        productIcmsAliquotCredit,
        setProductIcmsAliquotCredit,
        productIcmsCreditAprove,
        setProductIcmsCreditAprove,
        productIcmsStValueBcRet,
        setProductIcmsStValueBcRet,
        productIcmsAliquotSupCons,
        setProductIcmsAliquotSupCons,
        productIcmsOwnSubValue,
        setProductIcmsOwnSubValue,
        productIcmsStValueRet,
        setProductIcmsStValueRet,
        productIcmsStBcPovertyRet,
        setProductIcmsStBcPovertyRet,
        productIcmsStAliqPovertyRet,
        setProductIcmsStAliqPovertyRet,
        productIcmsStValuePovertyRet,
        setProductIcmsStValuePovertyRet,
        productIcmsPercentReduct,
        setProductIcmsPercentReduct,
        productIcmsModality,
        setProductIcmsModality,
        productIcmsAfrmm,
        setProductIcmsAfrmm,
        productIcmsValueBc,
        setProductIcmsValueBc,
        productIcmsAliquot,
        setProductIcmsAliquot,
        productIcmsValue,
        setProductIcmsValue,
        productIcmsValueDes,
        setProductIcmsValueDes,
        productImcsMotivoDes,
        setProductImcsMotivoDes,
        productIcmsAliquotPoverty,
        setProductIcmsAliquotPoverty,
        productIcmsBcPoverty,
        setProductIcmsBcPoverty,
        productIcmsValuePoverty,
        setProductIcmsValuePoverty,
        productIcmsStModality,
        setProductIcmsStModality,
        productIcmsStPercentAdd,
        setProductIcmsStPercentAdd,
        productIcmsStPercentReductBc,
        setProductIcmsStPercentReductBc,
        productIcmsStValueBc,
        setProductIcmsStValueBc,
        productIcmsStAliquot,
        setProductIcmsStAliquot,
        productIcmsStValue,
        setProductIcmsStValue,
        productIcmsStAliquotPoverty,
        setProductIcmsStAliquotPoverty,
        productIcmsStBcPoverty,
        setProductIcmsStBcPoverty,
        productIcmsStValuePoverty,
        setProductIcmsStValuePoverty,
        productIpiCenq,
        setProductIpiCenq,
        productIpiSituation,
        setProductIpiSituation,
        productIpiBcValue,
        setProductIpiBcValue,
        productIpiAliquot,
        setProductIpiAliquot,
        productIpiValue,
        setProductIpiValue,
        productIpiReturnedAliquot,
        setProductIpiReturnedAliquot,
        productIpiReturnedValue,
        setProductIpiReturnedValue,
        productPisSituation,
        setProductPisSituation,
        productPisPercentAliquot,
        setProductPisPercentAliquot,
        productPisAliquot,
        setProductPisAliquot,
        productPisBcValue,
        setProductPisBcValue,
        productPisValue,
        setProductPisValue,
        productCofinsSituation,
        setProductCofinsSituation,
        productCofinsPercentAliquot,
        setProductCofinsPercentAliquot,
        productCofinsAliquot,
        setProductCofinsAliquot,
        productCofinsBcValue,
        setProductCofinsBcValue,
        productCofinsValue,
        setProductCofinsValue,
        productDiTable,
        setProductDiTable,
        productIIUnityValue,
        setProductIIUnityValue,
        productIIFob,
        setProductIIFob,
        productIIFreightIm,
        setProductIIFreightIm,
        productIISafeIm,
        setProductIISafeIm,
        productIIThc,
        setProductIIThc,
        productIICustomsValue,
        setProductIICustomsValue,
        productIIOthers,
        setProductIIOthers,
        productIIAntidumping,
        setProductIIAntidumping,
        productIIAFRMM,
        setProductIIAFRMM,
        productIIBcTax,
        setProductIIBcTax,
        productIIAliquot,
        setProductIIAliquot,
        productIIAliquotRed,
        setProductIIAliquotRed,
        productIITaxCustoms,
        setProductIITaxCustoms,
        productIIIof,
        setProductIIIof,
        productIITaxIm,
        setProductIITaxIm,
        productB2BNumber,
        setProductB2BNumber,
        productB2BItem,
        setProductB2BItem,
        productFuelCodeAnp,
        setProductFuelCodeAnp,
        productFuelDescAnp,
        setProductFuelDescAnp,
        productFuelUf,
        setProductFuelUf,
        productFuelGlpPetroleum,
        setProductFuelGlpPetroleum,
        productFuelNationalGas,
        setProductFuelNationalGas,
        productFuelImportedGas,
        setProductFuelImportedGas,
        productFuelValueWithoutICMS,
        setProductFuelValueWithoutICMS,
        productIcmsAliquotInterstate,
        setProductIcmsAliquotInterstate,
        productIcmsAliquotInternal,
        setProductIcmsAliquotInternal,
        productTaxation,
        setProductTaxation,
        taxations,
        setTaxations,
        productCheckIcmsFreight,
        setProductCheckIcmsFreight,
        productCheckIcmsSafe,
        setProductCheckIcmsSafe,
        productCheckIcmsDifal,
        setProductCheckIcmsDifal,
        productCopyIcmsAliquotInterstate,
        setProductCopyIcmsAliquotInterstate,
        productCheckIcmsOthers,
        setProductCheckIcmsOthers,
        productCheckIcmsDiscount,
        setProductCheckIcmsDiscount,
        productCheckIpiFreight,
        setProductCheckIpiFreight,
        productCheckIpiSafe,
        setProductCheckIpiSafe,
        productCheckIpiOthers,
        setProductCheckIpiOthers,
        productCheckIpiDiscount,
        setProductCheckIpiDiscount,
        productCheckPisFreight,
        setProductCheckPisFreight,
        productCheckPisSafe,
        setProductCheckPisSafe,
        productCheckPisOthers,
        setProductCheckPisOthers,
        productCheckPisDiscount,
        setProductCheckPisDiscount,
        productCheckPisDescIcms,
        setProductCheckPisDescIcms,
        productCheckCofinsFreight,
        setProductCheckCofinsFreight,
        productCheckCofinsSafe,
        setProductCheckCofinsSafe,
        productCheckCofinsOthers,
        setProductCheckCofinsOthers,
        productCheckCofinsDiscount,
        setProductCheckCofinsDiscount,
        productCheckCofinsDescIcms,
        setProductCheckCofinsDescIcms,
        productIcmsCbenef,
        setProductIcmsCbenef,
        loading,
        setLoading,
        itemId,
        setItemId,
        productExportDrawbackNumber,
        setProductExportDrawbackNumber,
        productIsIndirectExportation,
        setProductIsIndirectExportation,
        productExportRegisterNumber,
        setProductExportRegisterNumber,
        productExportAccessKey,
        setProductExportAccessKey,
        productExportQuantity,
        setProductExportQuantity,
      }}
    >
      {children}
    </ParametrosProdutoContext.Provider>
  );
};

export { ParametrosProdutoContextProvider, ParametrosProdutoContext };
